import { styled } from "styled-components";
import { links } from "../../components/common/mixins";

export const Link = styled.a`
  ${links.linkMediumBrightPurple()}
`;

export const SmallLink = styled.a`
  ${links.linkSmallBrightPurple()} 
`
